import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMapLocationDot, faBus } from "@fortawesome/free-solid-svg-icons";
import "../../../../css/Turismo/turismo.css";

const terminal = [
  {
    nombre: "Terminal de Ómnibus",
    link: "https://maps.app.goo.gl/ZXVQPKDQuzR3YHox8",
    direccion: <>Leandro N. Alem 100.</>,
  },
  {
    nombre: "Boletería Oliva Córdoba – Coata",
    link: "https://maps.app.goo.gl/wYrL1CUXmyCCmACD7",
    direccion: (
      <>
        Leandro N. Alem 100.<br />
        Celular: 03532-15408957
      </>
    ),
  },
  {
    nombre: "Boletería Oliva Lep",
    link: "https://maps.app.goo.gl/wYrL1CUXmyCCmACD7",
    direccion: (
      <>
        Leandro N. Alem 100.<br />
        03532-15409034<br />
        03532-15417200
      </>
    ),
  },
];

const TerminalOmnibus = () => (
  <div>
    <div
      className="text-center"
      style={{
        backgroundImage: `url(${require("../../../img/Terminal01.jpeg")})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
        height: 450,
        marginBottom: 30,
        backgroundAttachment: "fixed",
      }}
    />
    <div className="container">
      <h1 className="text-center">
        <strong>TERMINAL DE ÓMNIBUS</strong>
      </h1>
      <br />
      <div className="row">
        <div className="col-12 col-md-6">
          <h5>
            <FontAwesomeIcon icon={faBus} style={{ color: "#2980b9", marginRight: 8 }} />
            Ubicación y boleterías
          </h5>
          <ul className="lista-referencias">
            {terminal.map((item, i) => (
              <li key={i}>
                <FontAwesomeIcon icon={faMapLocationDot} style={{ color: "#2980b9", marginRight: 8 }} />
                <a href={item.link} target="_blank" rel="noopener noreferrer">
                  {item.nombre}
                </a>
                <div className="ms-2 me-auto">{item.direccion}</div>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <br />
      <div className="text-center">
        <img
          src={require("../../../img/destacados/horarios-coata.png")}
          alt="Horarios Coata"
          style={{ maxWidth: "100%", height: "auto", marginBottom: 20 }}
        />
        <img
          src={require("../../../img/destacados/horarios-lep.png")}
          alt="Horarios Lep"
          style={{ maxWidth: "100%", height: "auto" }}
        />
      </div>
      <div className="text-center" style={{ margin: "30px 0" }}>
        <a href="/turismo" className="btn btn-primary">Volver a Turismo</a>
      </div>
    </div>
  </div>
);

export default TerminalOmnibus;
